import { useQuery } from '@tanstack/react-query';
import axiosInstance from '@/lib/helpers/axiosInstance';
import { orderBy } from 'lodash';

export const useGetDropdownOptions = async kind => {
  const url = `/api/v1/dropdown_options?kind=${kind}`;
  const { data } = await axiosInstance().get(url);
  return orderBy(data, ['id', 'asc']) || [];
};
